import { render, staticRenderFns } from "./OrdersCancelOrder.vue?vue&type=template&id=ca7ffc36&scoped=true&"
import script from "./OrdersCancelOrder.vue?vue&type=script&lang=js&"
export * from "./OrdersCancelOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7ffc36",
  null
  
)

export default component.exports